export default __webpack_public_path__ + "static/media/invoice_onboarding.17f347c8.png";